import React, { useState, useEffect } from 'react';
import { TextField, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface I18nFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  sx?: any;
  namespace?: string;
}

export const I18nField: React.FC<I18nFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  sx,
  namespace = '',
}) => {
  const { t, i18n } = useTranslation();
  const [translation, setTranslation] = useState<string>('');

  useEffect(() => {
    if (value) {
      const key = namespace ? `${namespace}.${value}` : value;
      const translated = t(key);
      setTranslation(translated);
    } else {
      setTranslation('');
    }
  }, [value, t, namespace]);

  const fullKey = namespace ? `${namespace}.${value}` : value;
  const hasTranslation = value && i18n.exists(fullKey);

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <TextField
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        fullWidth
        variant="outlined"
      />
      {value && (
        <Box sx={{ mt: 1, p: 1, bgcolor: 'grey.50', borderRadius: 1 }}>
          <Typography variant="caption" color="text.secondary" display="block">
            Translation Preview:
          </Typography>
          {hasTranslation ? (
            <Typography variant="body2" color="success.main">
              {translation}
            </Typography>
          ) : (
            <Typography variant="body2" color="warning.main">
              No translation found for "{namespace ? `${namespace}.${value}` : value}"
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
